export const specialSerie = ['461', '463', '906', '900'];
